const EXTERNAL_SEARCH_CONFIG = {
  enabled: /true/i.test(process.env.NEXT_PUBLIC_ENABLE_SEARCH_INDEX ?? ''),
  nodes:
    process.env.NEXT_PUBLIC_SEARCH_INDEX_HOSTPORTS?.split(',').map(
      (hostport) => {
        const [host, port] = hostport.split(':')
        return {
          host,
          port: +(port ?? 0),
          protocol: process.env.NODE_ENV === 'production' ? 'https' : 'http',
        }
      }
    ) ?? [],
  /**
   * @see keys.js
   */
  scopedApiKeys: {
    hasPublishedCourses:
      process.env.NEXT_PUBLIC_SEARCH_INDEX_HAS_PUBLISHED_COURSES_KEY ?? '',
    isPublished: process.env.NEXT_PUBLIC_SEARCH_INDEX_IS_PUBLISHED_KEY ?? '',
    isActive: process.env.NEXT_PUBLIC_SEARCH_INDEX_IS_ACTIVE_KEY ?? '',
  },
}

export default EXTERNAL_SEARCH_CONFIG
